import React from 'react';
import { connect } from 'react-redux';
import { isMobileBrowser } from '../../base/environment/utils';
import { translate } from '../../base/i18n/functions';
import Icon from '../../base/icons/components/Icon';
import { IconWarning } from '../../base/icons/svg';
import getUnsafeRoomText from '../../base/util/getUnsafeRoomText.web';
import CalendarList from '../../calendar-sync/components/CalendarList.web';
import RecentList from '../../recent-list/components/RecentList.web';
import { AbstractWelcomePage, _mapStateToProps } from './AbstractWelcomePage';
import Tabs from './Tabs';
/* vianova */
import LoginPopup from './LoginPopupVianova';
import LogoutPopup from './LogoutPopup';
import Logout from './Logout';
import GreetingsPopup from './GreetingsPopupVianova';
import ErrorPopup from './ErrorPopup';
import NewFeaturesPopup from './NewFeaturesPopup';
import RetryPopup from './RetryPopup';
import { getWSUrl } from '../functions';
import { _formatConferenceIDPin } from '../../invite/_utils';
import i18next from 'i18next';
import { getBrandColor, getBrandPathAndroid, getBrandPathIOS, getBrandInfoUrl, getBrandPrivacyUrl, getBrandTermsUrl, getBrandCookieUrl } from '../../utils/brandDomainUtils';
import { ASSET_VERSION_QUERY } from '../../utils/assetVersionQuery';
import Help145 from './Help-145';
/**
 * The pattern used to validate room name.
 *
 * @type {string}
 */
export const ROOM_NAME_VALIDATE_PATTERN_STR = "[0-9]*"; // solo numerico, prima era '^[^?&:\u0022\u0027%#]+$'
/**
 * Maximum number of pixels corresponding to a mobile layout.
 * @type {number}
 */
const WINDOW_WIDTH_THRESHOLD = 425;
/**
 * Length of the room code name
 */
const ROOM_NAME_LENGTH = 10;
/**
 * Name of the cookie for GDPR
 */
//const COOKIE_NAME = "accept-vianova-cookie";
/**
 * The Web container rendering the welcome page.
 *
 * @augments AbstractWelcomePage
 */
class WelcomePageVianova extends AbstractWelcomePage {
    _additionalContentRef;
    _additionalToolbarContentRef;
    _additionalCardRef;
    _roomInputRef;
    _additionalCardTemplate;
    _additionalContentTemplate;
    _additionalToolbarContentTemplate;
    _titleHasNotAllowCharacter;
    /**
     * Default values for {@code WelcomePage} component's properties.
     *
     * @static
     */
    static defaultProps = {
        _room: "",
    };
    /**
     * Initializes a new WelcomePage instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
        let us = localStorage.getItem("user");
        if (us != null) {
            var user = JSON.parse(us?.toString());
            if (user.result == 1) {
                this.state = {
                    ...this.state,
                    showRetryPopup: this.openRetryPopup(),
                    showErrorPopup: this.openErrorPopup(),
                    showGreetingsPopup: this.openGreetingsPopup(),
                    showLogoutPopup: this.openLogoutPopup(),
                    isLoggedIn: true,
                    gravatar: user.avatar == "" ? 'https://areaclienti.vianova.it/avatar/empty.png' : user.avatar,
                    name: user.name,
                    surname: user.surname,
                    roomID: user.roomname,
                    roomIDVisualize: this.codiceStanzaPerVisualizzazione(user.roomname),
                    codiceMago: user.customerCode,
                    inviteURL: this.inviteUrl(user.roomname),
                    errorePartecipa: "",
                    showNewsPopup: true,
                    showAgainNewsAugust2026: this.showNews(),
                    showAgainGreetings: this.showGreetings(),
                    token: user.token,
                    username: user.username
                };
            }
        }
        else {
            this.state = {
                ...this.state,
                generateRoomNames: interfaceConfig.GENERATE_ROOMNAMES_ON_WELCOME_PAGE,
                showLoginPopup: this.openLoginPopup(),
                showRetryPopup: this.openRetryPopup(),
                showErrorPopup: this.openErrorPopup(),
                showGreetingsPopup: this.openGreetingsPopup(),
                isLoggedIn: false,
                gravatar: "",
                name: "",
                surname: "",
                roomID: "",
                roomIDVisualize: "",
                codiceMago: "0",
                inviteURL: "",
                errorePartecipa: "",
                showNewsPopup: false,
                showAgainNewsAugust2026: 'false',
                showAgainGreetings: 'true',
                token: "",
                username: ""
            };
        }
        /*  this.state = {
                ...this.state,
                //acceptedCookie: (this._getCookie(COOKIE_NAME) == '1')
            } */
        /**
      * Used To display a warning massage if the title input has no allow character.
      *
      * @private
      * @type {boolean}
      */
        this._titleHasNotAllowCharacter = false;
        /**
         * The HTML Element used as the container for additional content. Used
         * for directly appending the additional content template to the dom.
         *
         * @private
         * @type {HTMLTemplateElement|null}
         */
        this._additionalContentRef = null;
        this._roomInputRef = null;
        /**
         * The HTML Element used as the container for additional toolbar content. Used
         * for directly appending the additional content template to the dom.
         *
         * @private
         * @type {HTMLTemplateElement|null}
         */
        this._additionalToolbarContentRef = null;
        this._additionalCardRef = null;
        /**
         * The template to use as the additional card displayed near the main one.
         *
         * @private
         * @type {HTMLTemplateElement|null}
         */
        this._additionalCardTemplate = document.getElementById('welcome-page-additional-card-template');
        /**
         * The template to use as the main content for the welcome page. If
         * not found then only the welcome page head will display.
         *
         * @private
         * @type {HTMLTemplateElement|null}
         */
        this._additionalContentTemplate = document.getElementById('welcome-page-additional-content-template');
        /**
         * The template to use as the additional content for the welcome page header toolbar.
         * If not found then only the settings icon will be displayed.
         *
         * @private
         * @type {HTMLTemplateElement|null}
         */
        this._additionalToolbarContentTemplate = document.getElementById('settings-toolbar-additional-content-template');
        // Bind event handlers so they are only bound once per instance.
        this._onFormSubmit = this._onFormSubmit.bind(this);
        this._onRoomChange = this._onRoomChange.bind(this);
        this._setAdditionalCardRef = this._setAdditionalCardRef.bind(this);
        this._setAdditionalContentRef
            = this._setAdditionalContentRef.bind(this);
        this._setRoomInputRef = this._setRoomInputRef.bind(this);
        this._setAdditionalToolbarContentRef
            = this._setAdditionalToolbarContentRef.bind(this);
        this._renderFooter = this._renderFooter.bind(this);
    }
    existPathname(path) {
        var fullPath = window.location.href;
        var searchPath = fullPath.search(path);
        if (searchPath > 0)
            return true;
        return false;
    }
    openGreetingsPopup() {
        return this.existPathname("#greetings");
    }
    openLoginPopup() {
        return this.existPathname("#login");
    }
    openErrorPopup() {
        return this.existPathname("#error");
    }
    openRetryPopup() {
        return this.existPathname("#retry");
    }
    openLogoutPopup() {
        return this.existPathname("#logout");
    }
    /**
      * Change Language
      */
    changeLanguage(newLanguage) {
        return () => {
            var buttonLang = 'btn-' + newLanguage;
            i18next.changeLanguage(newLanguage);
            var element = document.getElementById(buttonLang);
            var element2;
            if (element !== null)
                element.style.color = getBrandColor();
            if (buttonLang == 'btn-it') {
                element2 = document.getElementById('btn-en');
            }
            else {
                element2 = document.getElementById('btn-it');
            }
            if (element2 !== null)
                element2.style.color = 'rgb(0, 0, 0)';
        };
    }
    /**
      * Toggle popups
      */
    togglePopup(nomePopup) {
        if (nomePopup == "login") {
            this.setState({
                showLoginPopup: !this.state.showLoginPopup
            });
        }
        if (nomePopup == "error") {
            this.setState({
                showErrorPopup: !this.state.showErrorPopup,
            });
        }
        if (nomePopup == "retry") {
            this.setState({
                showRetryPopup: !this.state.showRetryPopup,
            });
        }
        if (nomePopup == "errorPartecipa") {
            this.setState({
                errorePartecipa: ""
            });
        }
        if (nomePopup == "greetings") {
            this.setState({
                showGreetingsPopup: !this.state.showGreetingsPopup
            });
        }
        if (nomePopup == "logout") {
            this.setState({
                showLogoutPopup: !this.state.showLogoutPopup
            });
        }
        if (nomePopup == "news") {
            this.setState({
                showNewsPopup: !this.state.showNewsPopup
            });
        }
        window.history.pushState('home', 'homepage', '/');
    }
    codiceStanzaPerVisualizzazione(roomName) {
        if (typeof roomName !== 'undefined') {
            if (roomName.length == 10) {
                return (roomName.substring(0, 3) +
                    " - " +
                    roomName.substring(3, 7) +
                    " - " +
                    roomName.substring(7));
            }
        }
    }
    visualizzazionePartecipa(roomName) {
        if (roomName.length >= 4 && roomName.length < 8) {
            return roomName.substring(0, 3) + " - " + roomName.substring(3); //( roomName.length > 8 ? roomName.substring(3, 7) + ' - ' + roomName.substring(7) : "" );
        }
        else if (roomName.length >= 8) {
            return (roomName.substring(0, 3) +
                " - " +
                roomName.substring(3, 7) +
                " - " +
                roomName.substring(7));
        }
        return roomName;
    }
    showNews() {
        if (localStorage.getItem("showAgainNewsAugust2026") != null) {
            return localStorage.getItem("showAgainNewsAugust2026");
        }
        else {
            return 'true';
        }
    }
    showGreetings() {
        if (localStorage.getItem("showAgainGreetings2") != null) {
            return localStorage.getItem("showAgainGreetings2");
        }
        else {
            return 'true';
        }
    }
    inviteUrl(roomName) {
        return "https://" + window.location.hostname + "/" + roomName;
    }
    redirectURL(type) {
        return "https://" + window.location.hostname + "/" + "note-legali/index.html" + type;
    }
    _copiaInvito(isEmail) {
        //TODO Rendere dinamico il numero di telefono.
        var invito = (isEmail ? "mailto:?subject=" + this.props.t("info.inviteURLFirstPartPersonal", { name: this.state.name + " " + this.state.surname, }) + "&body=" : "") +
            this.props.t("info.inviteURLFirstPartPersonal", {
                name: this.state.name + " " + this.state.surname,
            }) + this.props.t("info.inviteURLSecondPart", {
            url: this.state.inviteURL,
        }) + this.props.t("info.invitePhone", {
            number: this.props.t("info.numeroCallIn"),
            //number: _formatTelNumber(this.state.phoneNumber), //tra quelli dell'array "numbers" prendendo quello giusto per la lingua attualmente settata
            conferenceID: _formatConferenceIDPin(this.state.roomID) + "#",
        });
        if (isEmail) {
            return invito.toString().replace(/\n/g, '%0D%0A');
        }
        else {
            navigator.clipboard.writeText(invito);
            return '';
        }
    }
    _siteWI() {
        window.open(this.href.toString());
        return false;
    }
    href(href) {
        throw new Error('Method not implemented.');
    }
    handlePartecipaKeyPress = (event) => {
        if (event.key === "Enter") {
            this._onJoinRoom(this.state.room);
        }
    };
    /**
     * Cambio di stato da loggato/non loggato dopo il login
     */
    cambiaStatoLogin(risultatoLogin) {
        if (risultatoLogin.result == 1) {
            this.setState({
                isLoggedIn: !this.state.isLoggedIn, //true secco e duro
                gravatar: risultatoLogin.avatar,
                name: risultatoLogin.name,
                surname: risultatoLogin.surname,
                roomID: risultatoLogin.roomname,
                roomIDVisualize: this.codiceStanzaPerVisualizzazione(risultatoLogin.roomname),
                codiceMago: risultatoLogin.customerCode,
                inviteURL: this.inviteUrl(risultatoLogin.roomname),
                errorePartecipa: "",
                showAgainNewsAugust2026: 'true',
                showAgainGreetings: 'true'
            });
            //SALVO I DATI IN SESSIONE
            window.localStorage.setItem("user", JSON.stringify(risultatoLogin));
        }
    }
    /**
     * Implements React's {@link Component#componentDidMount()}. Invoked
     * immediately after this component is mounted.
     *
     * @inheritdoc
     * @returns {void}
     */
    componentDidMount() {
        super.componentDidMount();
        document.body.setAttribute("style", "font-family:Roboto !important;");
        document.body.classList.add("contenitore");
        document.title = interfaceConfig.APP_NAME;
        if (this.state.generateRoomNames) {
            this._updateRoomName();
        }
        if (this._shouldShowAdditionalContent()) {
            this._additionalContentRef?.appendChild(this._additionalContentTemplate?.content.cloneNode(true));
        }
        if (this._shouldShowAdditionalToolbarContent()) {
            this._additionalToolbarContentRef?.appendChild(this._additionalToolbarContentTemplate?.content.cloneNode(true));
        }
        if (this._shouldShowAdditionalCard()) {
            this._additionalCardRef?.appendChild(this._additionalCardTemplate?.content.cloneNode(true));
        }
        if (window.location.search) {
            var searchLang = window.location.search.replace("?lang=", "");
            if (searchLang) {
                if (searchLang == 'it' || searchLang == 'en')
                    i18next.changeLanguage(searchLang);
            }
        }
    }
    /**
     * Removes the classname used for custom styling of the welcome page.
     *
     * @inheritdoc
     * @returns {void}
     */
    componentWillUnmount() {
        super.componentWillUnmount();
        document.body.classList.remove("contenitore");
    }
    /**
    * Renders the header access.
    * @param {ReactElement} header header of the card
    */
    _renderAccessCard(header) {
        return React.createElement("div", { id: "access_card" }, header);
    }
    /**
    * Renders the card box.
    *
    * @param {ReactElement} header header of the card
    * @param {ReactElement} footer button of the card
    */
    _renderNewCard(header, header2, footer) {
        return (React.createElement("div", { id: "newcard" },
            React.createElement("div", { id: "header-container" }, header),
            React.createElement("div", { id: "header-container", style: { height: "10px" } }, header2),
            React.createElement("div", { id: "footer-container" }, footer)));
    }
    /**
     * Renders the Vianova welcome page
     */
    _renderWIUI() {
        const buttonAccedi = (React.createElement("div", null,
            React.createElement("button", { className: "button button--vianova", name: "buttonAccedi", onClick: this.state.room.length >= ROOM_NAME_LENGTH ? () => { this._onJoinRoom(this.state.room); } : this.togglePopup.bind(this, "login") }, this.state.room.length == ROOM_NAME_LENGTH ? this.props.t('VianovaWelcomePage.tastoPartecipa') : this.props.t('VianovaWelcomePage.nonLoggato.accedi')),
            this.state.showLoginPopup ?
                React.createElement(LoginPopup, { closePopup: this.togglePopup.bind(this, "login"), cambiaStatoLogin: this.cambiaStatoLogin.bind(this) })
                : null));
        //---------------------------------------------------------------------------------------
        // post login areaclienti -> this.state.isLoggedIn = 1
        //---------------------------------------------------------------------------------------
        const buttonAvvia = (React.createElement("div", null,
            React.createElement("button", { className: "button button--vianova", name: "buttonAvvia", onClick: this.state.room.length >= ROOM_NAME_LENGTH ? () => { this._onJoinRoom(this.state.room); } : () => { this._onJoinRoom(this.state.roomID); } }, this.state.room.length == ROOM_NAME_LENGTH && this.state.room != this.state.roomID ? this.props.t('VianovaWelcomePage.tastoPartecipa') : this.props.t('VianovaWelcomePage.loggato.avviaMeeting'))));
        //---------------------------------------------------------------------------------------
        // partecipa sempre presente sia pre che post login
        //---------------------------------------------------------------------------------------
        const sezionePartecipa = (React.createElement("div", { id: "sezionePartecipa", className: "sezionePartecipa" },
            React.createElement("input", { autoFocus: false, id: "testoPartecipa", className: "testoPartecipa", type: "text", placeholder: this.props.t('VianovaWelcomePage.placeHolderPartecipa'), 
                //maxLength="16"
                value: this.visualizzazionePartecipa(this.state.room), pattern: ROOM_NAME_VALIDATE_PATTERN_STR, onKeyPress: this.state.room.length == ROOM_NAME_LENGTH
                    ? this.handlePartecipaKeyPress
                    : () => null, onChange: (event) => this.setPartecipa(event), onPaste: (event) => this.setPartecipa(event) })));
        //---------------------------------------------------------------------------------------
        // link
        //---------------------------------------------------------------------------------------
        const sezioneLink = (React.createElement("div", { className: "sezioneLink" },
            React.createElement("div", { className: "sezioneLink-interna" },
                React.createElement("img", { className: "sezioneLink-img", src: `images/copy.png${ASSET_VERSION_QUERY}`, alt: "#" }),
                React.createElement("input", { id: "bottoneLink", type: "button", name: "buttonCopyLink", value: this.props.t('VianovaWelcomePage.loggato.copiaLink').toString(), className: `bottoneLink`, onClick: () => {
                        navigator.clipboard.writeText(this.state.inviteURL);
                        this._flashLinkCopied();
                    } }),
                this.state.linkCopied && (React.createElement("span", { className: 'sezioneLink-copiato' }, this.props.t('dialog.copied').toString()))),
            React.createElement("div", { className: "sezioneLink-interna" },
                React.createElement("img", { className: "sezioneLink-img", src: `images/copy.png${ASSET_VERSION_QUERY}`, alt: "#" }),
                React.createElement("input", { id: "bottoneLink", type: "button", name: "buttonCopyInvite", value: this.props.t('VianovaWelcomePage.loggato.copiaInvito').toString(), className: `bottoneLink`, onClick: () => {
                        this._copiaInvito(false);
                        this._flashInvitoCopied();
                    } }),
                this.state.invitoCopied && (React.createElement("span", { className: 'sezioneLink-copiato' }, this.props.t('dialog.copied').toString()))),
            React.createElement("div", { className: "sezioneLink-interna" },
                React.createElement("img", { className: "sezioneLink-img", src: `images/mail.png${ASSET_VERSION_QUERY}`, alt: "#", style: { marginLeft: "5px" } }),
                React.createElement("input", { id: "bottoneLink", type: "button", name: "buttonInvite", value: this.props.t('VianovaWelcomePage.loggato.invita').toString(), className: `bottoneLink`, onClick: event => window.location.href = this._copiaInvito(true) }))));
        //---------------------------------------------------------------------------------------
        // header Cambio lingua
        //---------------------------------------------------------------------------------------
        const headerChangeLanguage = (React.createElement("div", { className: "change-languages" },
            React.createElement("p", { className: "dist-pre-lang" }),
            React.createElement("button", { id: "btn-it", className: i18next.language == 'it' ? "btn-lang-current" : "btn-lang", onClick: this.changeLanguage("it") }, "IT"),
            React.createElement("span", { className: "dist-lang" }, "|"),
            React.createElement("button", { id: "btn-en", className: i18next.language == 'en' ? "btn-lang-current" : "btn-lang", onClick: this.changeLanguage("en") }, "EN")));
        //---------------------------------------------------------------------------------------
        // header Accesso non ancora avvenuto
        //---------------------------------------------------------------------------------------
        const headerNoAccess = (React.createElement("div", null,
            React.createElement("button", { className: "btn-log", onClick: this.togglePopup.bind(this, "login") },
                React.createElement("span", null,
                    " ",
                    this.props.t('VianovaWelcomePage.nonLoggato.accedi'),
                    " "),
                React.createElement("img", { src: `images/buttonAccedi.svg${ASSET_VERSION_QUERY}`, alt: "#" })),
            this.state.showLoginPopup ?
                React.createElement(LoginPopup, { closePopup: this.togglePopup.bind(this, "login"), cambiaStatoLogin: this.cambiaStatoLogin.bind(this) })
                : null));
        //---------------------------------------------------------------------------------------
        // header Accesso avvenuto
        //---------------------------------------------------------------------------------------
        const headerAccess = (React.createElement("div", { className: "header_accesso_effettuato" },
            React.createElement("div", { className: "testo_accesso_effettuato" },
                React.createElement("p", null,
                    this.props.t('VianovaWelcomePage.loggato.saluto'),
                    " ",
                    this.state.name,
                    " \u00A0 ")),
            React.createElement("img", { className: "gravatar", src: this.state.gravatar }),
            React.createElement(Logout, null)));
        //---------------------------------------------------------------------------------------
        // Visualizzazioni e renderizzazioni pagina
        //---------------------------------------------------------------------------------------
        return (React.createElement("div", { className: "contenitore" },
            React.createElement("header", { className: "headerVianova" },
                React.createElement("a", { className: "logoVianova", href: "https://www.vianova.it/", target: "_blank" },
                    React.createElement("img", { src: `images/logoVianova.svg${ASSET_VERSION_QUERY}`, alt: "#", style: { width: "auto", height: "26px" } })),
                React.createElement("div", { className: "header-right-container" },
                    React.createElement(Help145, null),
                    React.createElement("div", { className: "header-right" },
                        this.state.isLoggedIn == false ? headerNoAccess : headerAccess,
                        headerChangeLanguage))),
            React.createElement("section", { className: "container" },
                React.createElement("div", { className: "container_section left flex-center" },
                    React.createElement("div", { className: "box" },
                        React.createElement("div", null,
                            this.state.showGreetingsPopup && this.state.showAgainGreetings != 'false' && i18next.language == 'it' ?
                                React.createElement(GreetingsPopup, { closePopup: this.togglePopup.bind(this, "greetings") })
                                : null,
                            this.state.showErrorPopup ?
                                React.createElement(ErrorPopup, { closePopup: this.togglePopup.bind(this, "error") })
                                : null,
                            this.state.showLogoutPopup ?
                                React.createElement(LogoutPopup, { closePopup: this.togglePopup.bind(this, "logout") })
                                : null,
                            this.state.showRetryPopup ?
                                React.createElement(RetryPopup, { closePopup: this.togglePopup.bind(this, "retry") })
                                : null),
                        this.state.isLoggedIn == false ?
                            React.createElement("div", null,
                                React.createElement("span", null,
                                    React.createElement("span", { className: "container-meeting" }, "Meeting")),
                                React.createElement("img", { className: "container-img", src: `images/logo-meeting-vianova.svg${ASSET_VERSION_QUERY}`, alt: "#" }),
                                React.createElement("h1", { className: "testo_login" },
                                    this.props.t('VianovaWelcomePage.nonLoggato.benvenuto'),
                                    React.createElement("br", null),
                                    this.props.t('VianovaWelcomePage.nonLoggato.effettuaAccesso')),
                                sezionePartecipa,
                                buttonAccedi)
                            :
                                React.createElement("div", null,
                                    React.createElement("span", null,
                                        React.createElement("span", { className: "container-meeting" }, "Meeting")),
                                    React.createElement("img", { className: "container-img", src: `images/logo-meeting-vianova.svg${ASSET_VERSION_QUERY}`, alt: "#" }),
                                    React.createElement("h1", { className: "testo_login" },
                                        this.props.t('VianovaWelcomePage.loggato.organizzaMeeting1'),
                                        React.createElement("br", null),
                                        this.props.t('VianovaWelcomePage.loggato.organizzaMeeting2')),
                                    React.createElement("h2", { className: "testo_room_id" }, this.state.roomIDVisualize),
                                    sezioneLink,
                                    sezionePartecipa,
                                    buttonAvvia),
                        /* NEWS */
                        this.state.isLoggedIn == true && this.state.showNewsPopup == true && this.state.showAgainNewsAugust2026 == 'true' ?
                            React.createElement(NewFeaturesPopup, { closePopup: this.togglePopup.bind(this, "news") }) :
                            null,
                        /* CRONOLOGIA*/
                        this.state.isLoggedIn == true ?
                            React.createElement("div", { className: "cronologia" }, this._renderTabs())
                            :
                                null
                    /**/
                    ,
                        this.state.errorePartecipa != "" ?
                            React.createElement(ErrorPopup, { closePopup: this.togglePopup.bind(this, "errorPartecipa") })
                            : null,
                        this.state.isLoggedIn == false ? React.createElement("p", { style: { marginTop: "25px" } },
                            React.createElement("a", { className: "accent", href: "https://www.vianova.it/", target: "_blank" }, this.props.t('VianovaWelcomePage.nonLoggato.scopriDiPiu'))) : null)),
                React.createElement("div", { className: "container_section right flex-end", style: { backgroundColor: "#F5EDE7" } },
                    React.createElement("div", { className: "box vianova" },
                        React.createElement("img", { src: `images/home-vianova.svg${ASSET_VERSION_QUERY}`, alt: "#" })))),
            React.createElement("footer", { className: "footerVianova" },
                React.createElement("div", { className: "moreInfoPrivacyCookiesTerms" },
                    React.createElement("a", { style: { color: "#474747" }, target: "_blank", href: getBrandInfoUrl() }, this.props.t('VianovaWelcomePage.informazioni')),
                    React.createElement("a", { style: { color: "#474747", marginLeft: 40 }, target: "_blank", href: getBrandPrivacyUrl() }, this.props.t('VianovaWelcomePage.privacyPolicy')),
                    React.createElement("a", { style: { color: "#474747", marginLeft: 40 }, target: "_blank", href: getBrandCookieUrl() }, this.props.t('VianovaWelcomePage.cookiePolicy')),
                    React.createElement("a", { style: { color: "#474747", marginLeft: 40 }, target: "_blank", href: getBrandTermsUrl() }, this.props.t('VianovaWelcomePage.terminiUtilizzo'))),
                React.createElement("div", { className: "store" },
                    React.createElement("p", { className: "footer-text" }, this.props.t('VianovaWelcomePage.mobileMeetingApp')),
                    React.createElement("div", { className: "immaginiStore" },
                        React.createElement("a", { href: getBrandPathAndroid() },
                            React.createElement("img", { src: i18next.language == 'it' ? `images/google-play.svg${ASSET_VERSION_QUERY}` : `images/google-play-en.svg${ASSET_VERSION_QUERY}`, alt: "#", style: { width: "109px", maxWidth: "109px" } })),
                        React.createElement("a", { href: getBrandPathIOS() },
                            React.createElement("img", { src: i18next.language == 'it' ? `images/app-store.svg${ASSET_VERSION_QUERY}` : `images/app-store-en.svg${ASSET_VERSION_QUERY}`, alt: "#", style: { maxWidth: "97px" } })))))));
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement|null}
     */
    render() {
        const { _moderatedRoomServiceUrl, t } = this.props;
        const { DEFAULT_WELCOME_PAGE_LOGO_URL, DISPLAY_WELCOME_FOOTER } = interfaceConfig;
        const showAdditionalCard = this._shouldShowAdditionalCard();
        const showAdditionalContent = this._shouldShowAdditionalContent();
        const showAdditionalToolbarContent = this._shouldShowAdditionalToolbarContent();
        return this._renderWIUI();
    }
    /**
     * Renders the insecure room name warning.
     *
     * @inheritdoc
     */
    _doRenderInsecureRoomNameWarning() {
        return (React.createElement("div", { className: 'insecure-room-name-warning' },
            React.createElement(Icon, { src: IconWarning }),
            React.createElement("span", null, getUnsafeRoomText(this.props.t, 'welcome'))));
    }
    /**
     * Prevents submission of the form and delegates join logic.
     *
     * @param {Event} event - The HTML Event which details the form submission.
     * @private
     * @returns {void}
     */
    _onFormSubmit(event) {
        event.preventDefault();
        if (!this._roomInputRef || this._roomInputRef.reportValidity()) {
            this._onJoin();
        }
    }
    /**
     * handles the join conference button
     */
    _onJoinRoom(nomeStanza) {
        //console.log("MS -----> sono in _onJoinRoom per " + this.state.surname);
        let verify = "https://" + getWSUrl() + "/verifyMeetRoom/" + nomeStanza + "/0/";
        //console.log("MS -----> verifyMeetRoom da WelcomePage _onJoinRoom : " + verify);
        fetch(verify, { method: "GET" })
            .then((res) => res.json())
            .then((result) => {
            if (result.result == 1) {
                //Se la stanza esiste
                //console.log("MS -----> result 1 in WelcomePage.web, la stanza esiste ");
                //prima di chiamare la onJoin potrei lanciare la verifyProsodyToken visto che non lo facciamo più in conference.js
                this.setState({ room: nomeStanza }, () => this._onJoin());
            }
            else if (result.result == -1) {
                //console.log("MS -----> result diverso da 1 in WelcomePage.web");
                this.setState({ errorePartecipa: "Stanza non esistente.", });
                //ERROR 403, stanza non esistente
            }
            else {
                //console.log("MS -----> result diverso da 1 e -1 in WelcomePage.web");
                this.setState({ errorePartecipa: "Errore generico", });
            }
        }, (error) => {
            //console.log("MS -----> Errore generico: ");
            //console.log(error);
            this.setState({ errorePartecipa: "Errore generico." });
        });
    }
    showError() {
        //TODO
    }
    setPartecipa(event) {
        // solo numeri
        var roomCurrent = event.target.value.replace(window.location.origin, "").replace(/\D/g, "").replace("-", "").substring(0, ROOM_NAME_LENGTH);
        this.setState({ room: roomCurrent });
        var divo = document.getElementById("sezionePartecipa");
        var testo = document.getElementById("testoPartecipa");
        //cambiare border al div sezionePartecipa
        if (roomCurrent.length > 0) {
            if (divo !== null)
                divo.style.borderColor = getBrandColor();
            if (testo !== null)
                testo.style.fontSize = '17px';
        }
        else {
            if (divo !== null)
                divo.style.borderColor = '#cfcece';
            if (testo !== null)
                testo.style.fontSize = '15px';
        }
    }
    // @ts-ignore
    // eslint-disable-next-line require-jsdoc
    _onRoomChange(event) {
        const specialCharacters = ['?', '&', ':', '\'', '"', '%', '#', '.'];
        this._titleHasNotAllowCharacter = specialCharacters.some(char => event.target.value.includes(char));
        super._onRoomChange(event.target.value);
    }
    /**
     * Renders the footer.
     *
     * @returns {ReactElement}
     */
    _renderFooter() {
        const { t, _deeplinkingCfg: { ios = { downloadLink: undefined }, android = { fDroidUrl: undefined,
            downloadLink: undefined } } } = this.props;
        const { downloadLink: iosDownloadLink } = ios;
        const { fDroidUrl, downloadLink: androidDownloadLink } = android;
        return (React.createElement("footer", { className: 'welcome-footer' },
            React.createElement("div", { className: 'welcome-footer-centered' },
                React.createElement("div", { className: 'welcome-footer-padded' },
                    React.createElement("div", { className: 'welcome-footer-row-block welcome-footer--row-1' },
                        React.createElement("div", { className: 'welcome-footer-row-1-text' }, t('welcomepage.jitsiOnMobile')),
                        React.createElement("a", { className: 'welcome-badge', href: iosDownloadLink },
                            React.createElement("img", { alt: t('welcomepage.mobileDownLoadLinkIos'), src: `./images/app-store-badge.png${ASSET_VERSION_QUERY}` })),
                        React.createElement("a", { className: 'welcome-badge', href: androidDownloadLink },
                            React.createElement("img", { alt: t('welcomepage.mobileDownLoadLinkAndroid'), src: `./images/google-play-badge.png${ASSET_VERSION_QUERY}` })),
                        React.createElement("a", { className: 'welcome-badge', href: fDroidUrl },
                            React.createElement("img", { alt: t('welcomepage.mobileDownLoadLinkFDroid'), src: `./images/f-droid-badge.png${ASSET_VERSION_QUERY}` })))))));
    }
    /**
     * Renders tabs to show previous meetings and upcoming calendar events. The
     * tabs are purposefully hidden on mobile browsers.
     *
     * @returns {ReactElement|null}
     */
    _renderTabs() {
        if (isMobileBrowser()) {
            return null;
        }
        const { _calendarEnabled, _recentListEnabled, t } = this.props;
        const tabs = [];
        if (_calendarEnabled) {
            tabs.push({
                id: 'calendar',
                label: t('welcomepage.upcomingMeetings'),
                content: React.createElement(CalendarList, null)
            });
        }
        if (_recentListEnabled) {
            tabs.push({
                id: 'recent',
                label: t('welcomepage.recentMeetings'),
                content: React.createElement(RecentList, null)
            });
        }
        if (tabs.length === 0) {
            return null;
        }
        return (React.createElement(Tabs, { accessibilityLabel: t('welcomepage.meetingsAccessibilityLabel'), tabs: tabs }));
    }
    /**
     * Sets the internal reference to the HTMLDivElement used to hold the
     * additional card shown near the tabs card.
     *
     * @param {HTMLDivElement} el - The HTMLElement for the div that is the root
     * of the welcome page content.
     * @private
     * @returns {void}
     */
    _setAdditionalCardRef(el) {
        this._additionalCardRef = el;
    }
    /**
     * Sets the internal reference to the HTMLDivElement used to hold the
     * welcome page content.
     *
     * @param {HTMLDivElement} el - The HTMLElement for the div that is the root
     * of the welcome page content.
     * @private
     * @returns {void}
     */
    _setAdditionalContentRef(el) {
        this._additionalContentRef = el;
    }
    /**
     * Sets the internal reference to the HTMLDivElement used to hold the
     * toolbar additional content.
     *
     * @param {HTMLDivElement} el - The HTMLElement for the div that is the root
     * of the additional toolbar content.
     * @private
     * @returns {void}
     */
    _setAdditionalToolbarContentRef(el) {
        this._additionalToolbarContentRef = el;
    }
    /**
     * Sets the internal reference to the HTMLInputElement used to hold the
     * welcome page input room element.
     *
     * @param {HTMLInputElement} el - The HTMLElement for the input of the room name on the welcome page.
     * @private
     * @returns {void}
     */
    _setRoomInputRef(el) {
        this._roomInputRef = el;
    }
    /**
     * Returns whether or not an additional card should be displayed near the tabs.
     *
     * @private
     * @returns {boolean}
     */
    _shouldShowAdditionalCard() {
        return interfaceConfig.DISPLAY_WELCOME_PAGE_ADDITIONAL_CARD
            && this._additionalCardTemplate
            && this._additionalCardTemplate.content
            && this._additionalCardTemplate.innerHTML.trim();
    }
    /**
     * Returns whether or not additional content should be displayed below
     * the welcome page's header for entering a room name.
     *
     * @private
     * @returns {boolean}
     */
    _shouldShowAdditionalContent() {
        return (interfaceConfig.DISPLAY_WELCOME_PAGE_CONTENT &&
            this._additionalContentTemplate &&
            this._additionalContentTemplate.content &&
            this._additionalContentTemplate.innerHTML.trim());
    }
    /**
     * Returns whether or not additional content should be displayed inside
     * the header toolbar.
     *
     * @private
     * @returns {boolean}
     */
    _shouldShowAdditionalToolbarContent() {
        return (interfaceConfig.DISPLAY_WELCOME_PAGE_TOOLBAR_ADDITIONAL_CONTENT &&
            this._additionalToolbarContentTemplate &&
            this._additionalToolbarContentTemplate.content &&
            this._additionalToolbarContentTemplate.innerHTML.trim());
    }
    /**
     * Returns whether or not the screen has a size smaller than a custom margin
     * and therefore display different text in the go button.
     *
     * @private
     * @returns {boolean}
     */
    _shouldShowResponsiveText() {
        const { innerWidth } = window;
        return innerWidth <= WINDOW_WIDTH_THRESHOLD;
    }
}
export default translate(connect(_mapStateToProps)(WelcomePageVianova));
